import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { CurrentShopSelect } from "@/components/layout/shop-scope-select";
import { OperatingStrategyPage } from "@/components/operating-strategy/OperatingStrategyWizard";
import { requireModule } from "@/lib/module-access";
import { useOperatingStrategyStore } from "@/stores/operating-strategy";

export const Route = createFileRoute("/_authed/operating-strategy")({
  beforeLoad: () => requireModule("ai"),
  component: OperatingStrategyRoute,
});

function OperatingStrategyRoute(): React.ReactElement {
  const { t } = useTranslation("layout");
  // Switching Shops remounts the wizard under a new scope, silently dropping unsaved work.
  const wizardDirty = useOperatingStrategyStore((s) => s.wizardDirty);
  return (
    <>
      <div className="flex justify-end px-8 pt-5">
        <CurrentShopSelect
          disabled={wizardDirty}
          disabledReason={t("shopSwitcher.finishStrategyFirst")}
        />
      </div>
      <OperatingStrategyPage />
    </>
  );
}
